/**
 * common file for all string constants related to project.
 */

export const FREEZE_DATE_VALIDATION_MSG = "Please input freeze date";
export const MASTER_GROUP_VALIDATION_SELECT_MSG = "Please select product/partner";
export const IMS_MODULE_ID = 1005;
export const REFERENCE_AS_ELIGIBILITY_LOOKUP_ID = 300;
export const ERROR_IMPORT = 400;
